module.exports = __webpack_public_path__ + "img/go-back-left-arrow.cdc9bfba.svg";